module.exports = __webpack_public_path__ + "icon-open-policy-agent.2u_iZJjr.svg";